import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import ProviderSelect from 'components/TVE/ProviderSelect';

const iframeRef = React.createRef();

const SignIn = ({
  block,
  providerSelectVisible,
  showProviderSelect,
}) => (
  <div className={`${block}__sign-in`}>
    { providerSelectVisible && <ProviderSelect iframeRef={iframeRef} /> }
    {i18next.t('TO CONTINUE WATCHING')}
    <button type="button" className="icon icon-lock" onClick={showProviderSelect}>
      {i18next.t('Sign in')}
    </button>
  </div>
);

SignIn.propTypes = {
  block: PropTypes.string,
  providerSelectVisible: PropTypes.bool,
  showProviderSelect: PropTypes.func,
};

SignIn.defaultProps = {
  block: '',
  providerSelectVisible: false,
  showProviderSelect: Function.prototype,
};

export default SignIn;
